export default "__VITE_PUBLIC_ASSET__39ff8d81__"